module.exports = __webpack_public_path__ + "img/HQ-PA2W1CH_ALL.d54d671f.jpg";